import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  timeLabel: {
    id: 'portal.components.courseAccessButton.timeLabel.text',
    defaultMessage: 'Time',
    description: 'Time label',
  },
  accessLabel: {
    id: 'portal.components.courseAccessButton.accessLabel.text',
    defaultMessage: 'Access',
    description: 'Access label',
  },
  complete: {
    id: 'portal.components.courseAccessButton.complete.text',
    defaultMessage: 'Complete',
    description: 'Complete label',
  },
  availableNow: {
    id: 'portal.components.courseAccessButton.availableNow.text',
    defaultMessage: 'Available Now',
    description: 'Available Now label text',
  },
  completePreviousModule: {
    id: 'portal.components.courseAccessButton.completePreviousModule.text',
    defaultMessage: 'Complete Previous Module',
    description: 'Complete Previous Module label text',
  },
  signInToEnroll: {
    id: 'portal.components.courseAccessButton.signInToEnroll.text',
    defaultMessage: 'Sign in to enroll',
    description: 'Access status shown to guests prompting them to sign in before enrolling',
  },
});

export default messages;
